var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.dataset1)?_c('GxChart',{attrs:{"chartdata":_vm.dataset1,"labelX":"Dias","labelY":"m3/s"}}):_vm._e(),(_vm.dataset2)?_c('GxChart',{attrs:{"chartdata":_vm.dataset2,"labelX":"Dias","labelY":"Unidades"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }